import React, {useState} from 'react';
import '../styles/ReviewForm.css';
import StarRating from "../StarRating";

const ReviewForm = ({filmId, onSubmit}) => {
    const [formData, setFormData] = useState({
        rating: 0,
        reviewText: '',
        gender: '',
        ageGroup: '',
        heardFrom: '', // Maintenant c'est une string au lieu d'un tableau
        identifier: '',
        reviewerType: ''
    });
    const [errorMessage, setErrorMessage] = useState('');
    const [showError, setShowError] = useState(false);

   const ErrorModal = ({ message, onClose }) => (
  <div className="custom-alert-overlay">
    <div className="custom-alert">
      <div className="alert-header">
        <span>❌ Erreur</span>
      </div>
      <div className="alert-body">
        <p>{message}</p>
        <button className="close-btn" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  </div>
);

    const validateFields = () => {
        if (formData.rating === 0) {
            setErrorMessage("Veuillez attribuer une note avec les étoiles !");
            return false;
        }
        if (!formData.gender || !formData.ageGroup || !formData.heardFrom || !formData.reviewerType) {
            setErrorMessage("Veuillez remplir tous les champs obligatoires !");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateFields()) {
            setShowError(true);
            return;
        }

        try {
            const response = await fetch('https://api-4.africadataentry.net/api/ratings', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    filmID: parseInt(filmId),
                    score: parseInt(formData.rating),
                    comment: formData.reviewText,
                    genre: formData.gender,
                    tranche_age: formData.ageGroup,
                    film_connaissance: formData.heardFrom,
                    identifiant: formData.identifier,  // Champ optionnel
                    fonction: formData.reviewerType
                })
            });

            if (!response.ok) throw new Error('Erreur de soumission');


            const result = await response.json();
            // On suppose que le backend renvoie { message: ..., review: {...} }
            if (!result.review) {
                throw new Error('Aucune review retournée');
            }
            // Passez l'avis sauvegardé au composant parent
            onSubmit({
                ...result.review,
                createdAt: new Date(result.review.createdAt)
            });
            setFormData({
                rating: 0,
                reviewText: '',
                gender: '',
                ageGroup: '',
                heardFrom: '',
                identifier: '',
                reviewerType: ''
            });

        } catch (error) {
            console.error('Erreur:', error);
            setErrorMessage(error.message || "Une erreur inattendue est survenue");
            setShowError(true);
        }
    };

    return (
        <form className="review-form" onSubmit={handleSubmit}>
        {showError && <ErrorModal message={errorMessage} onClose={() => setShowError(false)} />}

            <h3>Donnez votre avis</h3>

            {/* Champ optionnel pour l'identifiant */}
            <div className="form-group">
            <div className="text-label">
                <label>Identifiant (optionnel) :</label>

                <input
                    type="text"
                    value={formData.identifier}
                    onChange={(e) => setFormData({ ...formData, identifier: e.target.value })}
                    placeholder="Nom, email, etc."
                />
                </div>
            </div>

            <div className="form-group">
                <label>Note(*) :</label>
                <StarRating
                    initialRating={formData.rating}
                    onRate={(newRating) => setFormData({ ...formData, rating: newRating })}
                />
            </div>

            <div className="form-group">
                <label>Commentaire(*) :</label>
                <textarea
                    value={formData.reviewText}
                    onChange={(e) => setFormData({...formData, reviewText: e.target.value})}
                    required
                />
            </div>

            <div className="form-group">
    <label>Genre(*) :</label>
    <div className="radio-group">
        <label className="radio-option">
            <input
                type="radio"
                name="gender"
                value="Masculin"
                checked={formData.gender === "Masculin"}
                onChange={(e) => setFormData({...formData, gender: e.target.value})}
                required
            />
            Homme
        </label>
        <label className="radio-option">
            <input
                type="radio"
                name="gender"
                value="Feminin"
                checked={formData.gender === "Feminin"}
                onChange={(e) => setFormData({...formData, gender: e.target.value})}
                required
            />
            Femme
        </label>
    </div>
</div>


<div className="form-group">
  <label>Tranche d'âge(*) :</label>
  <div className="radio-group-container">
    <div className="radio-group">
      {['-10', '10-18', '18-24','25-34','35-44','45+'].map((age) => (
        <label className="radio-option" key={age}>
          <input
            type="radio"
            name="ageGroup"
            value={age}
            checked={formData.ageGroup === age}
            onChange={(e) => setFormData({...formData, ageGroup: e.target.value})}
            required
          />
          <span>{age}</span>
        </label>
      ))}
    </div>
  </div>
</div>

<div className="form-group">
  <label>Comment avez-vous connu le film ?(*)</label>
  <div className="radio-group-container">
    <div className="radio-group">
      {['TV', 'Réseaux sociaux', 'Amis', 'Publicité', 'Bouche à oreille'].map((source) => (
        <label className="radio-option" key={source}>
          <input
            type="radio"
            name="heardFrom"
            value={source}
            checked={formData.heardFrom === source}
            onChange={(e) => setFormData({...formData, heardFrom: e.target.value})}
            required
          />
          <span>{source}</span>
        </label>
      ))}
    </div>
  </div>
</div>

<div className="form-group">
  <label>Vous êtes(*) :</label>
  <div className="radio-group-container">
    <div className="radio-group">
      {[
        { value: "Presse", label: "Presse" },
        { value: "Cinema", label: "Milieu du cinéma" },
        { value: "Cinephile", label: "Cinéphile" },
      ].map((option) => (
        <label className="radio-option" key={option.value}>
          <input
            type="radio"
            name="reviewerType"
            value={option.value}
            checked={formData.reviewerType === option.value}
            onChange={(e) => setFormData({ ...formData, reviewerType: e.target.value })}
            required
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  </div>

</div>

            <button type="submit">Soumettre</button>
        </form>
    );
};

export default ReviewForm;